import React, { useEffect } from 'react';
import { Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface AlertOverlayProps {
  message: string;
  variant?: 'success' | 'danger' | 'warning' | 'info';
  timeInSeconds?: number;
  onClose: () => void;
}

const AlertOverlay: React.FC<AlertOverlayProps> = ({ message, variant = 'info', timeInSeconds = 5, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, timeInSeconds * 1000);

    return () => clearTimeout(timer);
  }, [onClose, timeInSeconds]);

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '35%',
        zIndex: 9999,
      }}
    >
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="alert-tooltip">
            {message}
          </Tooltip>
        }
      >
        <Alert
          variant={variant}
          dismissible
          onClose={onClose}
          style={{
            margin: 0,
            wordBreak: 'break-word',
            display: 'block',
          }}
        >
          <div
            style={{
              overflow: 'visible',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              lineHeight: '1.5',
            }}
          >
            {message}
          </div>
        </Alert>
      </OverlayTrigger>
    </div>
  );
};

export default AlertOverlay;